function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Orion_plug Copy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "07-desktop-UI",
  transform: "translate(-1044.000000, -219.000000)",
  strokeWidth: 1.632
}, React.createElement("g", {
  id: "Orion_plug-Copy",
  transform: "translate(1045.000000, 220.000000)"
}, React.createElement("path", {
  d: "M11.8817204,23.4666667 L11.8817204,27.7333333 L7.56109482,27.7333333 L7.56109482,23.4666667 M9.72140762,27.7866667 L9.72140762,32",
  id: "Shape",
  stroke: "#6EC18A"
}), React.createElement("path", {
  d: "M17.2825024,8.53333333 L17.2825024,18.1333333 C17.2825024,19.5478213 16.7134931,20.9043755 15.70065,21.9045695 C14.6878069,22.9047635 13.3140969,23.4666667 11.8817204,23.4666667 L7.56109482,23.4666667 C4.57832528,23.4666667 2.16031281,21.078852 2.16031281,18.1333333 L2.16031281,8.53333333 M3.55271368e-15,8.53333333 L19.4428152,8.53333333 M5.40078201,8.53333333 L5.40078201,0 M14.0420332,8.53333333 L14.0420332,0",
  id: "Shape",
  stroke: "#3F5063"
}))));

var SvgPlug = function SvgPlug(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "22px",
    height: "34px",
    viewBox: "0 0 22 34",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlug, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plug.20372f0f.svg";
export { ForwardRef as ReactComponent };